module.exports = __webpack_public_path__ + "static/media/1.704f2716.JPG";